import React, {useState, useRef, useEffect} from "react";
import PropTypes from "prop-types";
import Table from "components/Table";
import useDictionary from "hooks/useDictionary";
import ScreenReaderLabel from "components/ScreenReaderLabel";
import Icon from "@cayuse/shared-react.components.icon";
import CovertButton from "@cayuse/shared-react.components.covert-button";

import styles from "./styles.css";

const ExpandableRow = ({ selectCheckbox, subContent, children, expandRow }) => {

    const { table: dictionary } = useDictionary("common");
    const  [ isExpanded, setIsExpanded ] = useState(false);
    const rowTogglerRef = useRef(null);

    const expandSubRows = () => {
        setIsExpanded(!isExpanded);
    };

    useEffect(()=>{
        rowTogglerRef.current.firstChild.setAttribute("data-icon", isExpanded ? "chevron-down" : "chevron-right");
    },[isExpanded])

    useEffect(()=>{
        setIsExpanded(expandRow);
    },[expandRow])


    return (
        <>
        <Table.Row data-component="Table\ExpandableRow">
            <Table.Cell>
                <CovertButton aria-expanded={isExpanded} ref={rowTogglerRef} onClick={expandSubRows}>
                    <Icon
                        name={"chevron-right"}
                    />
                    <span className="accessibility-text">Toggle sub-rows</span>
                </CovertButton>
            </Table.Cell>
            {selectCheckbox}
            {children}
        </Table.Row>
            {isExpanded ? subContent : ""}
        </>
    );
};

ExpandableRow.propTypes = {
    children: PropTypes.node
};

export default ExpandableRow;
